import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HhsgSharedQuicksightComponent } from './quicksight/quicksight.component';



@NgModule({
	imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
	declarations: [ 
        HhsgSharedQuicksightComponent
    ],
	exports: [
        HhsgSharedQuicksightComponent
    ]
}) 
export class HhsgSharedReportingModule {
}
